import { connectedStore } from '../../store';
import setSelectedElementAction from '../actions/set-selected-element';

const setSelectedElement = (elementId, options) => {
  const store = connectedStore.get();
  store.dispatch(setSelectedElementAction(elementId, options));
};

export default setSelectedElement;
